import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Layout, Menu } from "antd";
import logo from "./tramango-logo-black.png";
import {
  DashboardOutlined,
  DollarOutlined,
  MenuFoldOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { LogOut } from "../../features/auth/authThunk";
import { removeToken } from "../../utils/auth-helpers";
import { ROLE } from "../../utils/roles";
import { isDevEnv } from "../../utils/devEnv";

const { Sider } = Layout;
const { SubMenu } = Menu;

const Sidebar = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const pathname = location.pathname;
  const { admin } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(LogOut());
    removeToken();
  };

  const flightroles = [ROLE.SUPER, ROLE.ADMIN, ROLE.FLIGHT, ROLE.FINANCE];
  const insuranceroles = [ROLE.SUPER, ROLE.ADMIN, ROLE.FLIGHT, ROLE.INSURANCE];
  const financeroles = [ROLE.SUPER, ROLE.ADMIN, ROLE.FINANCE];
  const revenueroles = [ROLE.SUPER, ROLE.ADMIN, ROLE.FINANCE];
  const analyticsroles = [ROLE.SUPER, ROLE.ADMIN, ROLE.FINANCE, ROLE.MARKETING];
  const searchAnalyticsRoles = [ROLE.SUPER, ROLE.ADMIN, ROLE.MARKETING, ROLE.FINANCE];
  // SUPER only - see 149e024; admin account management is not for ROLE.ADMIN.
  const staffroles = [ROLE.SUPER];
  const userroles = [ROLE.SUPER, ROLE.ADMIN, ROLE.FLIGHT, ROLE.FINANCE, ROLE.MARKETING];
  const vaultroles = [ROLE.SUPER, ROLE.ADMIN, ROLE.FINANCE, ROLE.ENGINEER, ROLE.FLIGHT];
  const advertroles = [ROLE.SUPER, ROLE.ADMIN, ROLE.MARKETING];
  const packagesroles = [ROLE.SUPER, ROLE.ADMIN, ROLE.MARKETING];
  const discountroles = [ROLE.SUPER, ROLE.ADMIN, ROLE.FINANCE, ROLE.MARKETING];

  return (
    <Sider width={300} className="site-layout-background">
      <div className="logo" style={{ textAlign: "center", margin: "16px" }}>
        <img src={logo} alt="Logo" style={{ width: "125px", height: "auto" }} />
      </div>
      <Menu
        mode="inline"
        selectedKeys={[pathname]}
        defaultOpenKeys={["main", "lists", "useful", "service", "user"]}
        style={{ height: "100%", borderRight: 0 }}
      >
        <SubMenu key="main" icon={<DashboardOutlined />} title="MAIN">
          <Menu.Item key="/">
            <Link to="/">Dashboard</Link>
          </Menu.Item>
          {analyticsroles.includes(admin.admin_section_id) && (
            <Menu.Item key="/analytics">
              <Link to="/analytics">Analytics and Marketing Data</Link>
            </Menu.Item>
          )}
          {searchAnalyticsRoles.includes(admin.admin_section_id) && (
            <Menu.Item key="/search-analytics">
              <Link to="/search-analytics">Search Analytics</Link>
            </Menu.Item>
          )}
        </SubMenu>

        <SubMenu key="lists" icon={<MenuFoldOutlined />} title="LISTS">
          {userroles.includes(admin.admin_section_id) && (
            <Menu.Item key="/tramango-users">
              <Link to="/tramango-users">Tramango Users</Link>
            </Menu.Item>
          )}
          {discountroles.includes(admin.admin_section_id) && (
            <Menu.Item key="/discount">
              <Link to="/discount">Discounts</Link>
            </Menu.Item>
          )}
          {staffroles.includes(admin.admin_section_id) && (
            <Menu.Item key="/staff">
              <Link to="/staff">Staffs</Link>
            </Menu.Item>
          )}
          {financeroles.includes(admin.admin_section_id) && (
            <Menu.Item key="/finance">
              <DollarOutlined className="icon" />
              <Link to="/finance">Finance</Link>
            </Menu.Item>
          )}
          {revenueroles.includes(admin.admin_section_id) && (
            <Menu.Item key="/revenue">
              <Link to="/revenue">Revenue</Link>
            </Menu.Item>
          )}
          {flightroles.includes(admin.admin_section_id) && (
            <Menu.Item key="/flights">
              <Link to="/flights">Flights</Link>
            </Menu.Item>
          )}
          {insuranceroles.includes(admin.admin_section_id) && (
            <Menu.Item key="/insurance">
              <Link to="/insurance">Insurance</Link>
            </Menu.Item>
          )}
          {advertroles.includes(admin.admin_section_id) && (
            <Menu.Item key="/advert">
              <Link to="/advert">Advertisement</Link>
            </Menu.Item>
          )}
          {isDevEnv && packagesroles.includes(admin.admin_section_id) && (
            <Menu.Item key="/packages">
              <Link to="/packages">Packages & Quick Trips</Link>
            </Menu.Item>
          )}
          {vaultroles.includes(admin.admin_section_id) && (
            <Menu.Item key="/vault">
              <Link to="/vault">Tramango Vault</Link>
            </Menu.Item>
          )}
        </SubMenu>

        <SubMenu key="useful" icon={<MenuFoldOutlined />} title="USEFUL">
          <Menu.Item key="stats">
            <Link to="/stats">Stats</Link>
          </Menu.Item>
          <Menu.Item key="notifications">
            <Link to="/notifications">Notifications</Link>
          </Menu.Item>
        </SubMenu>

        <SubMenu key="service" icon={<MenuFoldOutlined />} title="SERVICE">
          {userroles.includes(admin.admin_section_id) && (
            <Menu.Item key="/twofactor">
              <Link to="/twofactor">2 Factor Authentication</Link>
            </Menu.Item>
          )}
          <Menu.Item key="system-health">System Health</Menu.Item>
          <Menu.Item key="logs">Logs</Menu.Item>
          <Menu.Item key="settings">Settings</Menu.Item>
        </SubMenu>

        <SubMenu key="user" icon={<MenuFoldOutlined />} title="USER">
          <Menu.Item key="profile">
            <Link to="/profile">Profile</Link>
          </Menu.Item>
          <Menu.Item key="logout" onClick={handleLogout}>
            <LogoutOutlined className="icon" />
            Logout
          </Menu.Item>
        </SubMenu>
      </Menu>
    </Sider>
  );
};

export default Sidebar;
